import React from "react";
import { useAuth } from "react-uicomp";
import Title from "../../common/title/Title.common";
import { FILE_URL } from "../../../config/Api.config";
import { getCurrentLanguage } from "../../../utils/getCurrentLanguage.util";

import { MEMBER_TYPES } from "../constant/memberTypes.constant";
import MAN_PLACEHOLDER from "../../../assets/images/man_placeholder.png";

export const Team = ({ teams }) => {
  const { language } = useAuth();
  const currentLanguage = getCurrentLanguage(language);

  return (
    <div className="ourteam-wrapper">
      <div className="container">
        {Object.keys(teams).map((val, index) => {
          return teams[val].length > 0 ? (
            <div className="teams" key={index}>
              <Title title={val} hide_SeeAll />

              <div className="cards-container">
                {teams[val].map((item, index) => {
                  const description = item?.description;
                  const image = description?.image;
                  const name = description?.name[currentLanguage];
                  const designation = description?.designation[currentLanguage];
                  const address = description?.address[currentLanguage];
                  const pdf = item?.pdf;

                  return (
                    <div className="wrapper" key={index}>
                      <div className="cards">
                        <div
                          className="image"
                          style={{
                            // backgroundImage: `url(${FILE_URL}/${image})`,
                            backgroundImage: `url(${
                              image ? FILE_URL + image : MAN_PLACEHOLDER
                            })`,
                            backgroundPosition: "center",
                          }}></div>
                        <div className="information">
                          <div className="name">{name}</div>
                          <div className="designation">{designation}</div>
                          <div className="address">{address}</div>
                        </div>
                        {!pdf ? (
                          <div className="cv-button" style={{ color: "#fff" }}>
                            &nbsp;
                          </div>
                        ) : (
                          <div
                            className="cv-button"
                            onClick={() => window.open(FILE_URL + pdf)}>
                            View CV
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null;
        })}
      </div>
    </div>
  );
};
